// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"8f0b62fc","498":"08e1e2c8","513":"4527d4cc","787":"c4e7f8f9"}[chunkId] + ".chunk.js";
};